(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455],{

/***/ 46127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgForosLogoWhite = function SvgForosLogoWhite(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 82 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#foros-logo-white_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M2.547 2.717v5.602h7.63c0 .888-.734 2.273-1.457 2.326H2.547v7.325C2.484 18.774.975 19.61 0 19.588V.402h11.529c0 .888-.723 2.272-1.447 2.315H2.547ZM43.368 5.994a3.058 3.058 0 0 0-.953-2.611 5.142 5.142 0 0 0-3.081-.72H36v6.85h3.144a7.278 7.278 0 0 0 2.505-.338 2.216 2.216 0 0 0 1.3-1.057c.305-.664.448-1.393.418-2.124Zm.294 12.79-4.35-7.019h-3.311v6.205c-.063.804-1.583 1.639-2.547 1.618V.402h5.91c2.37 0 4.057.444 5.084 1.321a5.014 5.014 0 0 1 1.234 1.862 5.05 5.05 0 0 1 .307 2.218 6.47 6.47 0 0 1-.923 3.71 4.73 4.73 0 0 1-3.05 1.84l1.049 1.617 3.73 5.952v.074l.105.148c-.796.539-2.494.655-2.966 0l-.23-.38-.042.02ZM82 14.345a5.165 5.165 0 0 1-.395 2.287 5.125 5.125 0 0 1-1.355 1.877A7.739 7.739 0 0 1 75.125 20a9.01 9.01 0 0 1-4.287-.919 6.958 6.958 0 0 1-2.809-2.843c1.667-1.184 2.788-.328 2.925-.18l.251.243a5.36 5.36 0 0 0 3.867 1.417 5.206 5.206 0 0 0 3.144-.846c.374-.259.677-.608.88-1.017.204-.409.301-.862.284-1.32a2.555 2.555 0 0 0-.367-1.426 3.338 3.338 0 0 0-.975-.983 5.836 5.836 0 0 0-1.394-.635 23.839 23.839 0 0 0-1.635-.465 56.393 56.393 0 0 1-2.61-.708 8.568 8.568 0 0 1-2.095-.951 4.286 4.286 0 0 1-1.394-1.49 4.738 4.738 0 0 1-.514-2.348 5.252 5.252 0 0 1 .374-2.198 5.213 5.213 0 0 1 1.25-1.84A7.033 7.033 0 0 1 74.937 0a7.681 7.681 0 0 1 4.119.962 7.19 7.19 0 0 1 2.431 2.473c-1.886 1.385-2.725.413-2.997.18l-.094-.095a5.477 5.477 0 0 0-.734-.57 5.08 5.08 0 0 0-2.725-.677 4.52 4.52 0 0 0-2.893.824 2.714 2.714 0 0 0-1.048 2.21c-.014.432.09.86.304 1.236.222.363.537.66.912.856.452.258.935.457 1.436.592l1.96.466c.86.232 1.687.475 2.463.729a7.695 7.695 0 0 1 2.096 1.004c.58.416 1.05.967 1.373 1.607.36.797.52 1.673.461 2.547Z",
    fill: "#fff"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M65.483 10.042c0 5.423-3.47 9.694-7.966 9.926h-.398c-.356 0-.66 0-.66-.328v-7.928l-2.494 2.315c-.367-.39-.598-1.321-.294-1.649L56.46 9.81V8.034l-2.211 2.04c-.367-.38-.598-1.31-.294-1.639l2.641-2.378.126-.116a.626.626 0 0 1 .44-.159c.162-.006.32.05.44.159l.126.116 2.568 2.4c.304.327.073 1.257-.294 1.638L57.79 8.034V9.82l2.788 2.569c.304.328.073 1.258-.304 1.649l-2.484-2.315v5.909c3.008-.423 5.356-3.658 5.356-7.59 0-4.228-2.704-7.632-6.027-7.632-3.322 0-6.016 3.425-6.016 7.632a8.816 8.816 0 0 0 1.593 5.17l.063.094a3.972 3.972 0 0 1-.419 2.94 10.47 10.47 0 0 1-2.7-3.697 10.554 10.554 0 0 1-.874-4.507c0-5.57 3.668-9.936 8.385-9.936 4.716 0 8.332 4.365 8.332 9.936Z",
    fill: "#D9B310"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.511 10.042c0 4.229 2.704 7.632 6.027 7.632 3.322 0 6.026-3.425 6.026-7.632S24.86 2.41 21.538 2.41c-3.323 0-6.027 3.425-6.027 7.632Zm14.38 0c0 5.582-3.669 9.947-8.385 9.947-4.716 0-8.384-4.365-8.384-9.947 0-5.581 3.668-9.936 8.384-9.936s8.384 4.365 8.384 9.936Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "foros-logo-white_svg__a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h82v20H0z"
  })))));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgForosLogoWhite);

/***/ }),

/***/ 33886:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(29541);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Contacts; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../core/src/components/ContactCard.tsx + 2 modules
var ContactCard = __webpack_require__(68921);
;// CONCATENATED MODULE: ../core/src/components/CountryOffice.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "flex-1 flex-col mb-16"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "font-poppins text-2xl mb-6"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "grid grid-flow-row grid-cols-1 md:grid-cols-3 gap-8 md:gap-14"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Wrapper = dist_default().div(_templateObject());
var Title = dist_default().p(_templateObject1());
var GridContainer = dist_default().div(_templateObject2());
var CountryOffice = function(param) {
    var countryCode = param.countryCode, flagEmoji = param.flagEmoji, representatives = param.representatives;
    var t = (0,esm/* useTranslation */.$G)('enum').t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                children: [
                    flagEmoji,
                    "\xa0",
                    t("CountryCode.".concat(countryCode))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridContainer, {
                children: representatives.map(function(c, i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ContactCard/* ContactCard */.M, _objectSpread({}, c), "ck-".concat(i));
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ../core/src/components/Navigation/NavBar.tsx + 7 modules
var NavBar = __webpack_require__(42234);
// EXTERNAL MODULE: ../core/src/components/Navigation/FooterLanding.tsx + 5 modules
var FooterLanding = __webpack_require__(56993);
// EXTERNAL MODULE: ../core/src/utils/index.ts
var utils = __webpack_require__(75920);
// EXTERNAL MODULE: ../core/src/config/domains.js
var domains = __webpack_require__(2811);
var domains_default = /*#__PURE__*/__webpack_require__.n(domains);
// EXTERNAL MODULE: ../graphql/src/generated/index.ts + 11 modules
var generated = __webpack_require__(63575);
;// CONCATENATED MODULE: ./src/pages/contact-us.tsx







function contact_us_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function contact_us_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            contact_us_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function contact_us_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function contact_us_templateObject() {
    var data = contact_us_taggedTemplateLiteral([
        "flex flex-col"
    ]);
    contact_us_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function contact_us_templateObject1() {
    var data = contact_us_taggedTemplateLiteral([
        "text-base md:text-lg mb-1 md:mb-2 text-gray-700"
    ]);
    contact_us_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Map = (0,utils/* clientOnlyModule */.EG)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9774), __webpack_require__.e(3164), __webpack_require__.e(499), __webpack_require__.e(4836), __webpack_require__.e(2074)]).then(__webpack_require__.bind(__webpack_require__, 64836));
});
var Marker = (0,utils/* clientOnlyModule */.EG)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9774), __webpack_require__.e(3164), __webpack_require__.e(7472)]).then(__webpack_require__.bind(__webpack_require__, 67472));
});
var Container = dist_default().div(contact_us_templateObject());
var ContactInfo = dist_default().p(contact_us_templateObject1());
var _contacts = (domains_default()).current.contacts, phoneNumber = _contacts.phoneNumber, email = _contacts.email;
var officeCoordinates = {
    lat: 54.687947,
    lng: 25.264014
};
var __N_SSG = true;
function Contacts() {
    var t = (0,esm/* useTranslation */.$G)('contacts').t;
    var data = (0,generated/* useContactsQuery */.Aa2)({
        fetchPolicy: 'cache-first'
    }).data;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBar/* NavBar */.l, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                    className: "container pt-14 pb-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-3xl md:text-5xl font-poppins font-bold mb-6 md:mb-10",
                            children: t('title')
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                            className: "flex-1 md:flex-row items-center justify-between mb-14",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                                    className: "max-w-md mr-0 md:mr-36 mb-8 md:mb-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactInfo, {
                                            children: t('companyName')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactInfo, {
                                            children: phoneNumber
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactInfo, {
                                            children: email
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactInfo, {
                                            children: [
                                                t('companyCode'),
                                                ": 303076369"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactInfo, {
                                            children: [
                                                t('vatPayerCode'),
                                                ": LT100011390613"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactInfo, {
                                            children: [
                                                t('address'),
                                                ": J. Jasinskio g. 12, LT-01112 Vilnius"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:flex-1 min-w-full md:min-w-0 h-48 md:h-72",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Map, {
                                        zoom: 15,
                                        center: officeCoordinates,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker, {
                                            position: officeCoordinates,
                                            popup: "FOROS Global \n J. Jasinskio g. 12, LT-01112 Vilnius"
                                        })
                                    })
                                })
                            ]
                        }),
                        data === null || data === void 0 ? void 0 : data.countryRepresentatives.map(function(co, i) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(CountryOffice, contact_us_objectSpread({}, co), "co-".concat(i));
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLanding/* FooterLanding */.m, {})
            ]
        })
    }));
};


/***/ }),

/***/ 68921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ ContactCard; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../core/src/components/ResponsiveImage.tsx
var ResponsiveImage = __webpack_require__(17094);
;// CONCATENATED MODULE: ../assets/icons/phone-green.png
/* harmony default export */ var phone_green = ({"src":"/_next/static/media/phone-green.363d617b.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEVMaXEaoYYaoYYaoYYaoYYaoYYaoYYaoYbuAd4sAAAACHRSTlMAhnZBCBZgMQ31jvwAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAuSURBVAiZPcrHDQAwDAJAisv+G1uyo/A6AcBP0wdZsXDpmiBLuybZzFXp3ZCBAQuaAGOQWTQDAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ../assets/icons/mail-green.png
/* harmony default export */ var mail_green = ({"src":"/_next/static/media/mail-green.face877b.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEVMaXEaooYaooYaoYYaoYcboYYaooYaoYYaoYYVLNWaAAAACXRSTlMAUj6NeyAcqWw+2Lg0AAAACXBIWXMAACE4AAAhOAFFljFgAAAAL0lEQVQImUXLsREAIBCEQLhX3/4rdkyUaBPgtaJZQFdSDYyte1yQcFEmFjBV558PEGsAa8/hBXYAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ../core/src/components/ContactCard.tsx







function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "font-poppins text-lg mb-2"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "text-sm"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "flex mr-5 rounded overflow-hidden"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "text-gray-700"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "flex flex-row items-center mb-3 md:mb-4"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "flex items-center mr-4"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
var Name = dist_default().p(_templateObject());
var Contact = dist_default().p(_templateObject1());
var ImgContainer = dist_default().div(_templateObject2());
var Title = dist_default()(Contact)(_templateObject3());
var RowContainer = dist_default().div(_templateObject4());
var InfoIcon = dist_default().div(_templateObject5());
var ContactCard = function(param) {
    var firstName = param.firstName, lastName = param.lastName, email = param.email, phoneNumber = param.phoneNumber, title = param.title, photoUrl = param.photoUrl;
    var t = (0,esm/* useTranslation */.$G)('enum').t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowContainer, {
                children: [
                    photoUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t, {
                            objectFit: "cover",
                            src: photoUrl,
                            sizes: [
                                70,
                                80
                            ],
                            unoptimized: true
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Name, {
                                children: [
                                    firstName,
                                    " ",
                                    lastName
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: t("RepresentativeTitle.".concat(title))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t, {
                            src: mail_green,
                            sizes: [
                                20,
                                30
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                        children: email
                    })
                ]
            }),
            phoneNumber ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t, {
                            src: phone_green,
                            sizes: [
                                20,
                                30
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                        children: phoneNumber
                    })
                ]
            }) : null
        ]
    }));
};


/***/ }),

/***/ 56993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ FooterLanding; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63964);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ../core/src/components/SvgIcon.tsx
var SvgIcon = __webpack_require__(16283);
// EXTERNAL MODULE: ../core/src/components/Navigation/NavLink.tsx
var NavLink = __webpack_require__(72499);
// EXTERNAL MODULE: ../core/src/config/theme.js
var theme = __webpack_require__(46487);
var theme_default = /*#__PURE__*/__webpack_require__.n(theme);
// EXTERNAL MODULE: ../assets/icons/foros-logo-white.svg
var foros_logo_white = __webpack_require__(46127);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../assets/icons/facebook.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 13 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.423 27V14.732h3.845l.57-4.79H8.422V6.904c0-1.4.366-2.34 2.217-2.34H13V.3A27.22 27.22 0 0 0 9.541.015a5.012 5.012 0 0 0-2.308.37A5.342 5.342 0 0 0 5.29 1.779a5.847 5.847 0 0 0-1.206 2.148 6.16 6.16 0 0 0-.24 2.496v3.52H0v4.79h3.845V27h4.578Z",
    fill: "#DDD"
  })));
};

/* harmony default export */ var facebook = (SvgFacebook);
;// CONCATENATED MODULE: ../assets/icons/linked-in.svg
var linked_in_path;

function linked_in_extends() { linked_in_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return linked_in_extends.apply(this, arguments); }



var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/react.createElement("svg", linked_in_extends({
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), linked_in_path || (linked_in_path = /*#__PURE__*/react.createElement("path", {
    d: "M.451 8.981h5.637V27H.45V8.981ZM3.27 0a3.264 3.264 0 0 1 3.023 2.029 3.283 3.283 0 0 1-.721 3.574 3.267 3.267 0 0 1-5.57-2.355C0 2.387.34 1.56.948.95A3.238 3.238 0 0 1 3.241 0h.028Zm6.285 27h5.637v-8.896c0-2.373.451-4.632 3.354-4.632s2.818 2.683 2.818 4.773V27H27v-9.885c0-4.858-1.071-8.473-6.708-8.473a5.852 5.852 0 0 0-5.298 2.825V8.98H9.639L9.554 27Z",
    fill: "#DDD"
  })));
};

/* harmony default export */ var linked_in = (SvgLinkedIn);
;// CONCATENATED MODULE: ../assets/icons/instagram.svg
var instagram_path;

function instagram_extends() { instagram_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return instagram_extends.apply(this, arguments); }



var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/react.createElement("svg", instagram_extends({
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), instagram_path || (instagram_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3a3 3 0 0 1 3-3h19.773a3 3 0 0 1 3 3v21a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Zm22.09 2.523a1.84 1.84 0 1 1-3.681 0 1.84 1.84 0 0 1 3.682 0ZM9 8.48a6.316 6.316 0 0 1 3.58-1.117c1.71 0 3.348.699 4.556 1.942a6.725 6.725 0 0 1 1.887 4.686c0 1.31-.377 2.592-1.085 3.682a6.486 6.486 0 0 1-2.892 2.44 6.277 6.277 0 0 1-3.723.378 6.39 6.39 0 0 1-3.299-1.814 6.688 6.688 0 0 1-1.763-3.393 6.803 6.803 0 0 1 .367-3.83A6.59 6.59 0 0 1 9 8.48Zm1.194 9.184a4.211 4.211 0 0 0 2.386.745c1.14 0 2.232-.466 3.038-1.294a4.483 4.483 0 0 0 1.258-3.124c0-.874-.252-1.728-.724-2.455a4.324 4.324 0 0 0-1.928-1.627 4.185 4.185 0 0 0-2.482-.252 4.26 4.26 0 0 0-2.2 1.21 4.459 4.459 0 0 0-1.175 2.262 4.536 4.536 0 0 0 .245 2.553 4.394 4.394 0 0 0 1.582 1.982Z",
    fill: "#DDD"
  })));
};

/* harmony default export */ var instagram = (SvgInstagram);
;// CONCATENATED MODULE: ../assets/icons/youtube.svg
var youtube_path;

function youtube_extends() { youtube_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return youtube_extends.apply(this, arguments); }



var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/react.createElement("svg", youtube_extends({
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), youtube_path || (youtube_path = /*#__PURE__*/react.createElement("path", {
    d: "M33.23 0H6.77a6.732 6.732 0 0 0-4.787 2.005A6.883 6.883 0 0 0 0 6.845v14.31c0 1.816.713 3.557 1.983 4.84A6.732 6.732 0 0 0 6.769 28h26.462a6.731 6.731 0 0 0 4.786-2.005A6.883 6.883 0 0 0 40 21.155V6.846a6.883 6.883 0 0 0-1.983-4.84A6.731 6.731 0 0 0 33.231 0Zm-5.396 14.274-12 6.222a.304.304 0 0 1-.409-.122.313.313 0 0 1-.04-.152V7.778a.313.313 0 0 1 .149-.264.305.305 0 0 1 .3-.01l12 6.222a.31.31 0 0 1 .167.277.314.314 0 0 1-.167.277v-.006Z",
    fill: "#DDD"
  })));
};

/* harmony default export */ var youtube = (SvgYoutube);
;// CONCATENATED MODULE: ../assets/images/climate-acc.jpg
/* harmony default export */ var climate_acc = ({"src":"/_next/static/media/climate-acc.39cfc554.jpg","height":3700,"width":16320,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAACAwEBAQAAAAAAAAAAAAABAgADBBEFIf/EABQBAQAAAAAAAAAAAAAAAAAAAAT/xAAYEQACAwAAAAAAAAAAAAAAAAAAAQMxQf/aAAwDAQACEQMRAD8AolmejF43otkprzsFY9qUIehTw/IiIuPQ7pH/2Q=="});
;// CONCATENATED MODULE: ../core/src/components/Navigation/FooterLanding.tsx














function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "flex flex-col"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "container py-9 md:py-16 md:flex-row gap-3"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "flex flex-1 flex-col-reverse gap-10 xl:flex-row"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "hidden md:flex space-x-8"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "flex mr-auto mb-10 md:mb-0"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "text-gray-400 mb-5"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 16px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  relative\n  flex\n  flex-1\n  md:self-end\n  xl:self-start\n  max-w-[400px]\n  min-h-[92px]\n  md:min-h-[80px]\n  xl:min-h-[92px]\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
var Column = dist_default().div(_templateObject());
var Container = dist_default()(Column)(_templateObject1());
var LinksContainer = dist_default().div(_templateObject2());
var IconContainer = dist_default().div(_templateObject3());
var Line = dist_default().div(_templateObject4());
var CredentialText = dist_default().p(_templateObject5());
var FooterLink = (0,styled_components_browser_esm/* default */.ZP)(NavLink/* NavLink */.O).withConfig({
    componentId: "sc-ae8a30eb-0"
})(_templateObject6(), (theme_default()).colors.gray[400]);
var ClimateImgContainer = dist_default().div(_templateObject7());
var FooterLanding = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-primary-500",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinksContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                            className: "mr-12 md:mr-24",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                    src: foros_logo_white/* default */.Z,
                                    width: 82,
                                    height: 20,
                                    className: "mb-7"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CredentialText, {
                                    children: t('copyright')
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CredentialText, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            className: "underline",
                                            href: "/rules",
                                            children: t('nav.rules')
                                        }),
                                        "\xa0•\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            className: "underline",
                                            href: "/privacy-policy",
                                            children: t('nav.privacyPolicy')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: "https://www.linkedin.com/company/foros-platform/",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                                src: linked_in,
                                                size: 27
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: "https://www.facebook.com/ForosLT",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                                src: facebook,
                                                width: 13,
                                                height: 27
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: "https://www.youtube.com/channel/UCKWsYIaiMQbsgW4Fle3uxcg",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                                src: youtube,
                                                width: 40,
                                                height: 28
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: "https://www.instagram.com/forosplatform/",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                                src: instagram,
                                                width: 26,
                                                height: 27
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column, {
                                    className: "space-y-2 mr-9",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            href: "/auctions",
                                            children: t('nav.auctions')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            href: "/about-us",
                                            children: t('nav.aboutUs')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            href: "/contact-us",
                                            children: t('nav.contactUs')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Column, {
                                    className: "space-y-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                        href: "/press",
                                        children: t('nav.pressRoom')
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClimateImgContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        src: climate_acc,
                        className: "w-full h-full",
                        objectFit: "contain",
                        objectPosition: "top",
                        layout: "fill"
                    })
                })
            ]
        })
    }));
};


/***/ }),

/***/ 17094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ ResponsiveImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75920);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96577);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32345);




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var ResponsiveImage = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .clientOnlyComponent */ .V4)(function(_param) {
    var sizes = _param.sizes, widths = _param.widths, heights = _param.heights, props = _objectWithoutProperties(_param, [
        "sizes",
        "widths",
        "heights"
    ]);
    var mobile = (0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useDeviceMediaQuery */ .mL)().mobile;
    var ref = _slicedToArray(widths !== null && widths !== void 0 ? widths : sizes, 2), mobileWidth = ref[0], desktopWidth = ref[1];
    var ref1 = _slicedToArray(heights !== null && heights !== void 0 ? heights : sizes, 2), mobileHeight = ref1[0], desktopHeight = ref1[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], _objectSpread({}, props, {
        width: mobile ? mobileWidth : desktopWidth,
        height: mobile ? mobileHeight : desktopHeight
    })));
});



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7362,1433,3442,2234,9774,2888,179], function() { return __webpack_exec__(33886); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);